<template>
  <div>
    <div id="appCapsule">
      <div class="section mt-2">
        <div class="card">
          <div class="card-body account-list-card">
            <div class="app-bill-pay-card">
              <div class="manage-bill-pay">
                <div class="biller-list">
                  <div class="billpay-desc">
                    <div class="billpay-desc-title">
                      Manage your bill payments.
                    </div>
                  </div>

                  <ul class="biller-list-ul"></ul>
                </div>
              </div>

              <div class="add-bill-pay" style="display: none;">
                <div class="biller-list">
                  <div class="billpay-desc">
                    <div class="billpay-desc-title">
                      Select biller.
                    </div>
                  </div>

                  <ul class="biller-list-ul">
                    <li
                      class="biller-list-li biller-btn"
                      data-biller-name="Amazon Prime"
                      data-biller-logo="amazon.svg"
                    >
                      <div class="biller-list-li-inner">
                        <div class="biller-list-col-one">
                          <div class="biller-info-logo">
                            <div
                              style="background-image: url(https://unifivaults.com/account/assets/img/brands/amazon.svg)"
                              class="biller-info-logo-svg"
                            ></div>
                          </div>
                          <div class="biller-info-details">
                            <div class="biller-info-name">
                              Amazon Prime
                            </div>
                            <div class="biller-info-desc">
                              E-commerce Company
                            </div>
                          </div>
                        </div>

                        <div class="biller-list-col-two">
                          <div class="biller-action-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      class="biller-list-li biller-btn"
                      data-biller-name="Apple Inc"
                      data-biller-logo="apple.svg"
                    >
                      <div class="biller-list-li-inner">
                        <div class="biller-list-col-one">
                          <div class="biller-info-logo">
                            <div
                              style="background-image: url(https://unifivaults.com/account/assets/img/brands/apple.svg)"
                              class="biller-info-logo-svg"
                            ></div>
                          </div>
                          <div class="biller-info-details">
                            <div class="biller-info-name">
                              Apple Inc
                            </div>
                            <div class="biller-info-desc">
                              Software Company
                            </div>
                          </div>
                        </div>

                        <div class="biller-list-col-two">
                          <div class="biller-action-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      class="biller-list-li biller-btn"
                      data-biller-name="Netflix Inc"
                      data-biller-logo="netflix.svg"
                    >
                      <div class="biller-list-li-inner">
                        <div class="biller-list-col-one">
                          <div class="biller-info-logo">
                            <div
                              style="background-image: url(https://unifivaults.com/account/assets/img/brands/netflix.svg)"
                              class="biller-info-logo-svg"
                            ></div>
                          </div>
                          <div class="biller-info-details">
                            <div class="biller-info-name">
                              Netflix Inc
                            </div>
                            <div class="biller-info-desc">
                              Streaming Service
                            </div>
                          </div>
                        </div>

                        <div class="biller-list-col-two">
                          <div class="biller-action-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      class="biller-list-li biller-btn"
                      data-biller-name="AT&T Inc"
                      data-biller-logo="at-t.svg"
                    >
                      <div class="biller-list-li-inner">
                        <div class="biller-list-col-one">
                          <div class="biller-info-logo">
                            <div
                              style="background-image: url(https://unifivaults.com/account/assets/img/brands/at-t.svg)"
                              class="biller-info-logo-svg"
                            ></div>
                          </div>
                          <div class="biller-info-details">
                            <div class="biller-info-name">
                              AT&T Inc
                            </div>
                            <div class="biller-info-desc">
                              Telecommunications Company
                            </div>
                          </div>
                        </div>

                        <div class="biller-list-col-two">
                          <div class="biller-action-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      class="biller-list-li biller-btn"
                      data-biller-name="Meta Platforms"
                      data-biller-logo="meta.svg"
                    >
                      <div class="biller-list-li-inner">
                        <div class="biller-list-col-one">
                          <div class="biller-info-logo">
                            <div
                              style="background-image: url(https://unifivaults.com/account/assets/img/brands/meta.svg)"
                              class="biller-info-logo-svg"
                            ></div>
                          </div>
                          <div class="biller-info-details">
                            <div class="biller-info-name">
                              Meta Platforms
                            </div>
                            <div class="biller-info-desc">
                              Technology Company
                            </div>
                          </div>
                        </div>

                        <div class="biller-list-col-two">
                          <div class="biller-action-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="biller-list-details" style="display: none;">
                  <form
                    method="POST"
                    id="payBillForm"
                    class="dyno-form"
                    onsubmit="return payBillFunction(event)"
                    autocomplete="off"
                  >
                    <div class="form-group">
                      <label class="mt-form-label">Biller Name</label><br />
                      <input
                        type="text"
                        name="biller_name"
                        id="biller_name"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label class="mt-form-label"
                        >Your
                        <span id="billAccUsername"></span>
                        Account Name</label
                      ><br />
                      <input
                        type="text"
                        name="bill_username"
                        id="bill_username"
                        placeholder="Your Account Name"
                        class="form-control"
                      />
                    </div>

                    <div class="form-group">
                      <label class="mt-form-label">Select Account</label><br />
                      <select
                        id="selectAccount"
                        name="select_account"
                        class="form-control"
                        style="width: 100%; height: 45px;"
                      >
                        <option
                          v-for="account in accounts"
                          :key="account.id"
                          :value="account.id"
                          :data-account_number="account.number"
                          >{{ account.type }} ****
                          {{ account.number.slice(-4) }}
                          {{ account.currency.symbol
                          }}{{ parseFloat(account.balance).toFixed(2) }}</option
                        >
                      </select>
                    </div>

                    <div class="form-group mt-no-upper">
                      <label class="mt-form-label">Payment Type</label><br />
                      <select
                        name="bill_payment_type"
                        class="form-control select2-no-search"
                        style="width: 100%; height: 45px;"
                      >
                        <option value="Recurring">Recurring</option>
                        <option value="One Time">One Time</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label class="mt-form-label">Bill Amount</label><br />
                      <input
                        type="text"
                        name="bill_amount"
                        id="trAmount"
                        class="form-control"
                        data-type="currency"
                        placeholder="$1.00"
                      />
                    </div>

                    <div class="form-group">
                      <label class="mt-form-label">Billing Date</label><br />
                      <input
                        type="date"
                        name="billing_date"
                        id="billing_date"
                        class="form-control"
                      />
                    </div>

                    <input
                      type="hidden"
                      name="logged_user"
                      value="665585dacefb1"
                    />
                    <input
                      type="hidden"
                      name="account_currency"
                      id="accountCurrency"
                      class="accountCurrency"
                    />
                    <input
                      type="hidden"
                      name="account_number"
                      id="sourceAccount"
                      class="sourceAccount"
                    />
                    <input type="hidden" name="biller_logo" id="biller_logo" />

                    <div class="form-group submit">
                      <button
                        type="button"
                        class="btn btn-secondary bill-go-back"
                      >
                        Go Back
                      </button>
                      <input
                        type="submit"
                        name="save"
                        value="Save"
                        class="btn btn-primary"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="actionLoader"></div>
    <!-- * App Capsule -->

    <div class="absolute-btn-container">
      <a href="javascript:void(0)" class="button" id="addBillPay">
        <button class="x-add-acc-btn">
          <ion-icon name="add-outline"></ion-icon>
        </button>
      </a>
      <a
        href="javascript:void(0)"
        class="button"
        id="goBackBillPay"
        style="display: none;"
      >
        <button class="x-add-acc-btn">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </button>
      </a>
    </div>
  </div>
</template>
<script>
import { RepositoryFactory as Repo } from "../../../repository/RepositoryFactory";
const AR = Repo.get("users");
export default {
  data() {
    return {
      accounts: [],
    };
  },

  created() {
    AR.loggedInUser().then((response) => {
      this.accounts = response.data.accounts;
    });
  },
};
</script>
